module.exports = __webpack_public_path__ + "img/db6b3ba.jpg";